<app-layer-config-collapsible-category
  class="border-bottom border-darkgray"
  description="Road Coverage"
  storageKey="vzo-road-coverage"
>
  <div style="display: flex; align-items: flex-start">
    <app-layer-control-item
      description="Road Coverage"
      [isLayerVisibile]="isRoadCoverageLayerVisible"
      [layerId]="layerIds.RoadCoverage.name"
      icon="speedometer-high"
      (visibilityToggled)="toggleLayerVisbility($event)"
      rbDetailsToggle
      [isOpen]="detailsOpen"
      #triggerDetails="rbDetailsToggle"
    ></app-layer-control-item>
  </div>
</app-layer-config-collapsible-category>
